import React from "react"
import PropTypes from "prop-types"
import Layout from "components/molecules/Layout"
import SEO from "components/molecules/SEO"
import { Information } from "components/molecules/PublicInformation"

const PrivateMaterial = ({ pageContext: { language } }) => (
  <Layout language={language}>
    <SEO
      title="Project information"
      meta={[{ name: "robots", content: "noindex, follow" }]}
    />
    <Information>
      <h1>Project reports</h1>
      <p>
        Investor briefings and reports are not published on this public website.
      </p>
      <p>
        Existing investors can use their established{" "}
        <a href="https://investors.appfolioim.com/exdev/investor/login">
          investor portal
        </a>{" "}
        or contact their Exdev representative.
      </p>
      <p>
        <a href="/en/portfolio">Return to the public property portfolio</a>
      </p>
    </Information>
  </Layout>
)
PrivateMaterial.propTypes = {
  pageContext: PropTypes.shape({ language: PropTypes.string }).isRequired,
}
export default PrivateMaterial
